import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/kolanoconnect.webp';

const KolaboConnect = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="kolanoConnect"
            logo={logo}
            primaryColor="#06036e"
            secondaryColor="#0A9D0E"
        />
    );
};

export default KolaboConnect;
